/* eslint-disable consistent-return */
/* eslint-disable no-dupe-keys */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
/**
 * If any changes made in this file will not be directly reflect in Dev/QA environment.
 * Please work with CICD team to apply changes in environemts.
 */
import React, {
  useCallback,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useMemo,
  useEffect,
} from 'react';
import { v4 as uuidv4 } from 'uuid';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry } from '@ag-grid-community/core';
import { CsvExportModule } from '@ag-grid-community/csv-export';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import CustomHeader from './customHeader';
import CustomLoadingCellRenderer from './CustomComponentsForTable/loadingSpinnerRenderer';
import Spinner from '../Spinner/SpinnerNew';
import DisplayErrorMessages from '../Errors/ErrorMessages';
import * as constantMessageData from '../Errors/constantMessageData';
import PDFExportPanel from '../pdfExport/PDFExportPanel';
import './tablegridfeature.scss';
import {
  handleCommaSeparatedAmount,
  handleOnColumnMoved,
  removeCommaForNumberFiled,
  removeDollarForNumberFiled,
  removeDoubleQueFiled,
  removePercentageForNumberFiled,
  removeWhiteSpaceForNDC,
  replaceCommaIntoWhiteSpace,
  replaceWhiteSpaceIntoString,
} from '../CommonUtilities/commonUtilities';
import { dispatchFilterAndSortFun, dispatchTableLoader } from './store/Actions';
import {
  applySavedColumnState,
  attachColumnStatePersistence,
  checkNumber,
  getColumnStateKey,
} from '../utilities/utilities';

import { LicenseManager } from 'ag-grid-enterprise';

LicenseManager.setLicenseKey(
  `Using_this_AG_Grid_Enterprise_key_( AG-044905 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Conduent Business Services US )_is_granted_a_( Single Application )_Developer_License_for_the_application_( CMDS Rebate )_only_for_( 3 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_( CMDS Rebate )_need_to_be_licensed___( CMDS Rebate )_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 7 August 2024 )____[v2]_MTcyMjk4NTIwMDAwMA==7d3fdf2a8bb7b8a59cef99172fd4b11d`
);


ModuleRegistry.registerModules([CsvExportModule]);
const KEY_LEFT = 'ArrowLeft';
const KEY_RIGHT = 'ArrowRight';

const customProcessCellCallback = (params, isCSV = false) => {
  if (params.column.colDef.pdfExportOptions?.skipColumn) {
    return null;
  }

  let { value } = params;
  if (params?.node?.data?.isBottomRow && value === 'Totals:') {
    return 'Totals:';
  }
  if (
    params?.node?.data?.isBottomRow &&
    (params.column.colDef.field === 'ndc' ||
      params.column.colDef.field === 'interestCalc ' ||
      params.column.colDef.field === 'interestSettledInd') &&
    (!value || value === '' || value === ' ' || value?.trim() === '')
  ) {
    return '';
  }
  if (
    params.column.getColDef().valueFormatter &&
    params.column.getColDef().exportOption?.enableValueFormatter
  ) {
    const formattedValue = params.column.getColDef().valueFormatter({
      ...params,
      data: {
        ...params.data,
        ...params.node?.data,
      },
    });
    value = formattedValue;
  }

  // Handling amounts and other conditions
  if (
    params.column?.colDef?.isAmount &&
    value !== '' &&
    value !== 0 &&
    value !== '0.00' &&
    !value?.toString()?.includes('%')
  ) {
    value = Math.round(100 * value) / 100;
  }

  if (params.column?.colDef?.showDropDownVal) {
    value = params?.node?.data[params?.column?.colDef.dropDownValueCol];
    value = value === '-1' ? '' : value;
  }

  if (params.column?.colDef?.isTextColorRed) {
    value = removeCommaForNumberFiled(value);
  }

  // Handling zero formatting for different conditions
  if (params.column?.colDef?.exportZeroesOne) {
    if (checkNumber(value)) {
      value = parseFloat(
        value?.toString()?.replace(',', '').trim()
      )?.toLocaleString('en-US', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    } else {
      value = '0.0';
    }
  } else if (params.column?.colDef?.exportZeroesTwo && value) {
    if (checkNumber(value)) {
      value = parseFloat(
        value?.toString()?.replace(',', '').trim()
      )?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else {
      value = '0.00';
    }
  } else if (params.column?.colDef?.exportZeroesThree && value) {
    if (checkNumber(value)) {
      value = parseFloat(
        value?.toString()?.replace(',', '').trim()
      )?.toLocaleString('en-US', {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      });
    } else {
      value = '0.000';
    }
  } else if (params.column?.colDef?.exportZeroesFour && value) {
    if (checkNumber(value)) {
      value = parseFloat(
        value?.toString()?.replace(',', '').trim()
      )?.toLocaleString('en-US', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      });
    } else {
      value = params?.node?.data?.isBottomRow ? value : '0.0000';
    }
  } else if (
    (params.column?.colDef?.exportZeroSix ||
      params.column?.colDef?.exportZeroesSix) &&
    value
  ) {
    if (checkNumber(value)) {
      value = parseFloat(
        value?.toString()?.replace(',', '').trim()
      )?.toLocaleString('en-US', {
        minimumFractionDigits: 6,
        maximumFractionDigits: 6,
      });
    } else {
      value = '0.000000';
    }
  } else if (
    value &&
    !isNaN(parseFloat(value)) &&
    params.column?.colDef?.excelAlignment
  ) {
    value = parseFloat(value?.toString()?.replace(',', '').trim());
  }

  // Apply changes to currency and percentages
  if (
    !isCSV &&
    params.column?.colDef?.excelAlignment &&
    !params.column?.colDef?.printPrefixValue?.includes('$') &&
    !params.column?.colDef?.printPostfixValue?.includes('%') &&
    !value?.toString()?.includes('$') &&
    !value?.toString()?.includes('%') &&
    value
  ) {
    value = `${value}~=~${params.column?.colDef.excelAlignment}`;
  }

  // Prefix handling
  if (params.column?.colDef?.printPrefixValue) {
    if (params.column?.colDef?.isAmount && value === 0) {
      value = '0.00';
    }
    if (value?.toString()?.includes('%')) {
      value = `${value}`;
    }
    value =
      value === '' ? '' : `${params.column?.colDef?.printPrefixValue}${value}`;
  }

  // Postfix handling
  if (params.column?.colDef?.printPostfixValue) {
    if (params.column?.colDef?.isAmount && value === 0) {
      value = '0.00';
    }
    value =
      value === '' ? '' : `${value}${params.column?.colDef?.printPostfixValue}`;
  }

  if (params.column?.colDef?.removeWhiteSpaceForNDC) {
    value = removeWhiteSpaceForNDC(value);
  }

  // Checkbox Icon Handling
  if (
    value?.toString() === 'Valid' &&
    params.column?.colDef?.showCheckboxIcon
  ) {
    value = '1';
  } else if (
    value?.toString() === 'Invalid' &&
    params.column?.colDef?.showCheckboxIcon
  ) {
    value = '0';
  } else if (
    params.column?.colDef?.showCheckboxIcon &&
    !params?.node?.data?.isBottomRow
  ) {
    value = value?.toString() === 'true' || value?.toString() === '1' ? 1 : 0;
  }

  // Null and invalid values handling
  if (
    value === null ||
    value === 'Invalid date' ||
    value === undefined ||
    value === '-1'
  ) {
    value = '';
  }

  // CSV handling
  if (isCSV && params.value && typeof params.value === 'string')
    value = params.value.includes(',') ? `"${params.value}"` : params.value;

  // Handle values with currency or percent symbols
  if ((params.value || params.value === 0) && !isNaN(params.value)) {
    if (params.column.getColDef().exportOption?.printWithCurrency)
      value = `${
        params.column.getColDef().exportOption?.printWithCurrency
      } ${value}`;
  }

  // Remove dollar signs, handle negative numbers, and format right alignment
  if (!value?.toString()?.includes('(')) {
    if (
      !isCSV &&
      (value?.toString()?.includes('$') ||
        params.column?.colDef.exportOption?.printWithCurrency)
    ) {
      const formattedValue = removeDollarForNumberFiled(value || 0)?.trim();
      value = handleCommaSeparatedAmount(
        replaceCommaIntoWhiteSpace(formattedValue || 0)
      );
      value = value === '' ? '' : value;
    }
  } else if (
    !isCSV &&
    value?.toString()?.includes(')') &&
    value?.toString()?.includes('(') &&
    (value?.toString()?.includes('$') ||
      params.column?.colDef.exportOption?.printWithCurrency) &&
    (params.column?.colDef?.alignRight ||
      params.column?.colDef.cellStyle?.textAlign === 'right')
  ) {
    const formattedValue = removeDollarForNumberFiled(value)?.trim();
    const dollarVal = formattedValue?.split('(')[1]?.trim();
    const AmountVal = dollarVal?.split(')')[0]?.trim();
    value = `- ${handleCommaSeparatedAmount(
      replaceCommaIntoWhiteSpace(AmountVal || 0)
    )}`; // Replaced parentheses with minus sign
  }

  // If zero and alignment is required
  if (
    !isCSV &&
    params.column?.colDef?.excelAlignment &&
    value?.toString() === '0'
  ) {
    value = `${value}~=~${params.column?.colDef.excelAlignment}`;
  }

  return value;
};

const customProcessHeaderCallback = (params) => {
  if (params.column.colDef.pdfExportOptions?.skipColumn) {
    return null;
  }
  if (params.column.getColDef().headerName?.includes('.')) {
    return replaceWhiteSpaceIntoString(params.column.getColDef().headerName);
  }
  return params.column.getColDef().headerName;
};

const TableGridWithFeatures = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const filterAndSortList = useSelector(
    (state) => state.sharedState?.TableGridReducer?.filterAndSortList
  );
  const tableLoader = useSelector(
    (state) => state.sharedState?.TableGridReducer?.tableLoader
  );
  const gridRef = useRef();
  const totalResultsRef = useRef(null);
  const sideBarPanelRef = useRef(null);
  const detachColStateRef = useRef(null);
  const [gridApi, setGridApi] = useState(gridRef);
  const [gridParams, setGridParams] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [showError, setShowError] = useState(false);
  const [applyFilter, setApplyFilter] = useState(!!props.applyFilter);
  const [totalCount, setTotalCount] = useState(0);
  const {
    persistColumnLayout,
    columnStateId,
    info = {},
    suppressQuotesOverride,
    isScrollOn,
    defaultColWidth,
    exportOnlyTotal,
    fullScreenView,
    fileName,
    childPopup,
    gridHeight,
    exportFile,
    exportWithOtherOption,
    rowData,
    columnDefs,
    context,
    cellClickedListener,
    onCellValueChanged,
    frameworkComponents,
    defaultCol = {},
    overlayNoRowsTemplate,
    onGridReady,
    suppressNavigation,
    onSelect,
    singleClickEdit,
    rowSelection,
    rowMultiSelectWithClick,
    onSelectionChanged,
    isModalTable = false,
    navigateToNextCell,
    hideColumnsInPdf,
    tabToNextCell,
    suppressRowClickSelection,
    enterMovesDown,
    noGlobalSort,
    suppressCellFocus,
    onCellFocused,
    handleFullScreenView,
    handleAddNewRow,
    onFilterData,
    handleFullScreenViewClick,
    gridCall,
    hideTotalCount,
    addButtonText,
    addTxt,
    addAction,
    rowClassRules,
    isPlanScreen,
    handleClickOpenDelete,
    goToClient,
    goToGroup,
    goToRebateManage,
    pinnedBottomRowData,
    handleViewHistory,
    helpMessage,
    disableAdd,
    showFooterForPDF,
    footerVariable,
    planByCGP,
    selectRowIndex,
    disableAddAction,
    researchActions,
    isAllocatePaymentScreen,
    isAllocatePayment,
    uraFlag,
    checkAllocatePqasScreen,
    handleResearchInvoiceAmount,
    handleResearchAdjustments,
    handleResearchPayments,
    onSortChanged,
    navigateHandler,
    showAdditionalOptions = false,
    showGoToNDCOptions = false,
    showMailoutOptions,
    mailoutHandler,
    headerHeight,
    skipColumnHeaders = false,
    activeInvoiceNum,
    activeCheckLogNum,
    customPDFExport,
    exportAllTpPDF,
    exportToPDF,
    exportAllE,
    exportAllLEFTE,
    showExportPdfOption = true,
    exportAllToXlsx,
    exportAllToXlsx1,
    exportAllToXlsx2,
    download,
    exportAllToCSV,
    getFilterApply,
    countValue,
    reportName,
    reduxState,
    totalResult,
    skipHeaderRow,
    handleOptionForDisputedClaims,
    skipAlertPopup = false,
    handleFreezeValuesPopup = false,
    onCellKeyDown = false,
    enableFocusOnFirstRender,
    gridDataRendered,
    freezeDisabled,
    exportAllTpPDFOne,
    providerAllClaimPDFExport,
    onRowDataUpdated,
    onModelUpdated,
    onBodyScrollEnd,
  } = props;
  const infoRowCount = info.rowCount;
  const totalResultsToDisplay = Number.isFinite(Number(infoRowCount))
    ? Number(infoRowCount)
    : totalResult ?? totalCount;
  const displayCount = Number.isFinite(Number(totalResultsToDisplay))
    ? Number(totalResultsToDisplay)
    : 0;
  const defaultColDef = useMemo(() => {
    return {
      editable: true,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
      suppressColumnMoveAnimation: true,
      headerComponentParams: {
        menuIcon: 'fa-bars',
      },
      ...defaultCol,
      suppressKeyboardEvent: suppressNavigation,
      suppressKeyboardEvent: (params) => {
        // Left & Right arrow movement
        const { key } = params.event;
        if (
          (key === KEY_LEFT || key === KEY_RIGHT) &&
          params.node.rowIndex > -1
        ) {
          return true;
        }
      },
    };
  }, []);
  const loadingCellRendererParams = useMemo(() => {
    return {
      loadingMessage: 'One moment please...',
    };
  }, []);
  React.useEffect(() => {
    if (columnDefs?.length > 0) {
      columnDefs.map((item, index) => {
        if (item.columnSpan) {
          for (let i = 1; i <= item.columnSpan; i += 1) {
            if (columnDefs[index + i]?.removeColumn) {
              columnDefs[index + i].hideColumnName = item.field;
            }
          }
        }
        return item;
      });
    }
  }, []);
  React.useEffect(() => {
    if (gridRef?.current?.api && setTotalCount) {
      const count = gridRef.current.api.getDisplayedRowCount();
      if (
        count === 0 &&
        gridRef?.current?.api?.filterManager?.activeColumnFilters?.length > 0
      )
        setShowError(true);
      else setShowError(false);
      setTotalCount(count);
    }
  });
  React.useEffect(() => {
    if (!persistColumnLayout) return;
    const api = gridRef?.current?.api || gridApi;
    const colApi = gridRef?.current?.columnApi || columnApi;
    if (!api || !colApi) return;

    const key = getColumnStateKey({
      columnStateId,
      fileName,
      pathname: window.location.pathname,
    });
    applySavedColumnState(api, colApi, key);
  }, [
    persistColumnLayout,
    columnStateId,
    fileName,
    gridApi,
    columnApi,
    tableLoader,
  ]);
  React.useEffect(() => {
    return () => {
      if (detachColStateRef.current) {
        detachColStateRef.current();
        detachColStateRef.current = null;
      }
    };
  }, []);
  const components = useMemo(() => {
    return { agColumnHeader: CustomHeader };
  }, []);
  useImperativeHandle(ref, () => ({
    addTBillRate() {
      return gridRef.current.api.setColumnDefs(columnDefs);
    },
    clearFilters() {
      return (
        gridRef?.current?.api?.setFilterModel(null),
        columnApi?.applyColumnState({
          defaultState: { sort: null },
        })
      );
    },
  }));

  useEffect(() => {
    if (getFilterApply) getFilterApply(applyFilter);
  }, [applyFilter]);
  const loadingCellRenderer = useMemo(() => {
    return CustomLoadingCellRenderer;
  }, []);
  const handleOnGridReady = useCallback(
    (params) => {
      if (params.api) {
        const columnToolPanel = params.api?.getToolPanelInstance('columns');
        if (columnToolPanel?.getGui) {
          const gui = columnToolPanel.getGui();
          if (gui) {
            sideBarPanelRef.current = gui.closest('.ag-side-bar') || gui;
          }
        }
        if (
          columnToolPanel?.setColumnLayout &&
          columnDefs?.filter((x) => x.columnSpan)?.length > 0
        ) {
          columnToolPanel.setColumnLayout(
            columnDefs?.filter((x) => {
              return x.headerName !== '';
            })
          );
        }
        setGridApi(params.api);
        setColumnApi(params.columnApi);
        setGridParams(params);
        addFilterForTable(params);
        if (persistColumnLayout) {
          const key = getColumnStateKey({
            columnStateId,
            fileName,
            pathname: window.location.pathname,
          }); // apply saved state (if any)
          applySavedColumnState(params.api, params.columnApi, key); // attach listeners to persist further changes
          if (detachColStateRef.current) detachColStateRef.current();
          detachColStateRef.current = attachColumnStatePersistence(
            params.api,
            params.columnApi,
            key
          );
        }
        if (gridCall) {
          gridCall(params);
        }
        if (onGridReady) {
          onGridReady(params);
        }
      }
    },
    [persistColumnLayout, columnStateId, fileName, props.gridCall]
  );
  const onFilterChanged = (e) => {
    const gridName = `${window.location.pathname?.replace('/', '')}-${
      fileName?.includes(' ') ? fileName?.split(' ')?.join('') : fileName
    }`;
    setTotalCount(e?.api?.getDisplayedRowCount());
    if (
      (e?.api.getFilterModel() && Object.keys(e?.api?.getFilterModel()))
        ?.length > 0
    ) {
      setApplyFilter(true);
      dispatch(
        dispatchFilterAndSortFun({
          ...filterAndSortList,
          [gridName]: {
            ...filterAndSortList[gridName],
            activeURL: window.location.pathname,
            filter: e.api.getFilterModel(),
          },
        })
      );
    } else {
      dispatch(
        dispatchFilterAndSortFun({
          ...filterAndSortList,
          [gridName]: {
            ...filterAndSortList[gridName],
            activeURL: window.location.pathname,
            filter: [],
          },
        })
      );
      setApplyFilter(false);
      if (onFilterData) onFilterData([], 'clearFilter');
    }
    const rowsData = [];
    e.api.forEachNodeAfterFilter((node) => {
      rowsData.push(node.data);
    });
    if (onFilterData) {
      const result = new Promise(() => {
        onFilterData(rowsData, 'filter');
      });
    }
  };
  // Debounce the onFilterChanged function
  const debouncedOnFilterChanged = debounce(onFilterChanged, 300);
  const onFilterChangedWrapper = (e) => {
    debouncedOnFilterChanged(e);
  };
  const onColumnPinned = useCallback(
    (e) => {
      const gridName = `${window.location.pathname?.replace('/', '')}-${
        fileName?.includes(' ') ? fileName?.split(' ')?.join('') : fileName
      }`;
      if (
        e?.columnApi?.getColumnState() &&
        Object.keys(e?.columnApi?.getColumnState())?.length > 0
      ) {
        dispatch(
          dispatchFilterAndSortFun({
            ...filterAndSortList,
            [gridName]: {
              ...filterAndSortList[gridName],
              activeURL: window.location.pathname,
              sort: e?.columnApi?.getColumnState(),
            },
          })
        );
      }
      gridRef.current.api.setColumnDefs(columnDefs);
    },
    [filterAndSortList]
  );
  const handleClearFilter = () => {
    if (gridRef?.current?.api?.setFilterModel) {
      gridRef.current.api.setFilterModel(null);
    }
    setApplyFilter(false);
    if (onFilterData) onFilterData([], 'clearFilter');
  };
  useEffect(() => {
    if (gridRef?.current?.columnApi?.resetColumnState) {
      gridRef.current.columnApi.resetColumnState();
    }
    handleClearFilter();
  }, [countValue]);
  const ExportCsv = (fname) => {
    setTimeout(() => dispatch(dispatchTableLoader(false)), 500);
    // Get all visible columns
    const displayedColumns =
      gridRef?.current?.columnApi.getAllDisplayedColumns();
    const finalColumnKeys = displayedColumns
      .map((col) => col.colId || col.field || col.headerName)
      .filter((colId) => {
        if (!colId || colId === '0') return false;
        if (hideColumnsInPdf && colId === hideColumnsInPdf[0]) return false;
        const colDef = columnDefs
          ?.flatMap((column) => (column.children ? column.children : [column]))
          .find((child) => (child.field || child.colId) === colId);
        if (colDef?.pdfExportOptions?.skipColumn) return false;
        return true;
      });
    return gridRef.current.api.exportDataAsCsv({
      fileName: `${
        fname ? `${fname}.csv` : fileName ? `${fileName}.csv` : 'data.csv'
      }`,
      columnKeys: finalColumnKeys,
      suppressQuotes: !suppressQuotesOverride,
      processCellCallback: (params) => {
        const tempObj = { ...params };
        if (tempObj.column?.colDef?.removeWhiteSpaceForNDC) {
          tempObj.value = removeWhiteSpaceForNDC(tempObj.value);
        }
        if (tempObj.column?.colDef?.removeuuidNDC) {
          if (tempObj?.node?.data?.isBottomRow) {
            tempObj.value = ' ';
          }
          const dataUUIDRemove = tempObj?.value
            ? tempObj?.value?.toString()?.split('//')[0]
            : '0';
          tempObj.value = dataUUIDRemove;
        }
        if (
          tempObj?.value?.toString() === 'true' &&
          tempObj?.column?.colDef?.showCheckboxIcon
        ) {
          tempObj.value = 1;
        }

        if (tempObj.column?.colDef?.showDropDownVal) {
          tempObj.value =
            tempObj?.node?.data[tempObj?.column?.colDef.dropDownValueCol];
          tempObj.value = tempObj.value === '-1' ? '' : tempObj.value;
        }
        if (tempObj.column?.colDef?.printPrefixValue) {
          if (params.column?.colDef?.isAmount && tempObj.value == 0) {
            tempObj.value = '0.00';
          }
          if (tempObj.value?.toString()?.includes('%')) {
            tempObj.value = `${tempObj.value}`;
          } else {
            if (params.column?.colDef?.exportZeroesOne) {
              if (checkNumber(tempObj.value)) {
                tempObj.value = parseFloat(tempObj.value)?.toFixed(1);
              } else {
                tempObj.value = '0.0';
              }
            } else if (params.column?.colDef?.exportZeroesTwo) {
              if (checkNumber(tempObj.value)) {
                tempObj.value = parseFloat(
                  tempObj.value?.toString()?.replace(',', '').trim()
                )?.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                });
              } else {
                tempObj.value = '0.00';
              }
            } else if (params.column?.colDef?.exportZeroesThree) {
              if (checkNumber(tempObj.value)) {
                tempObj.value = parseFloat(tempObj.value).toFixed(3);
              } else {
                tempObj.value = '0.000';
              }
            } else if (params.column?.colDef?.exportZeroesFour) {
              if (checkNumber(tempObj.value)) {
                tempObj.value = parseFloat(tempObj.value).toFixed(4);
              } else {
                tempObj.value = '0.0000';
              }
            } else if (
              params.column?.colDef?.exportZeroSix ||
              params.column?.colDef?.exportZeroesSix
            ) {
              if (checkNumber(tempObj.value)) {
                tempObj.value = parseFloat(tempObj.value).toFixed(6);
              } else {
                tempObj.value = '0.000000';
              }
            } else if (
              !isNaN(parseFloat(tempObj.value)) &&
              tempObj.value &&
              params.column?.colDef?.excelAlignment
            ) {
              tempObj.value = parseFloat(tempObj.value).toFixed(2);
            }

            tempObj.value =
              tempObj.value !== ''
                ? `${tempObj.column?.colDef?.printPrefixValue}${tempObj.value}`
                : '';
          }
        }

        if (tempObj.column?.colDef?.printPostfixValue) {
          if (tempObj.column?.colDef?.isAmount && tempObj.value === 0) {
            tempObj.value = '0.00';
          }
          tempObj.value =
            tempObj.value === ''
              ? ''
              : `${tempObj.value}${tempObj.column?.colDef?.printPostfixValue}`;
        }
        if (tempObj.value?.toString()?.includes('%')) {
          tempObj.value = `${removePercentageForNumberFiled(tempObj.value)} %`;
        }
        if (tempObj.column?.colDef?.isTextColorRed) {
          if (tempObj.node?.data?.isBottomRow) {
            tempObj.value =
              tempObj.node?.data[tempObj.column?.colDef.field] === ''
                ? ''
                : removeCommaForNumberFiled(tempObj.value || '');
          } else {
            tempObj.value = removeCommaForNumberFiled(tempObj.value || 0);
          }
        }

        if (
          tempObj?.value?.toString() === 'Valid' &&
          tempObj?.column?.colDef?.showCheckboxIcon
        ) {
          tempObj.value = '1';
        } else if (
          tempObj?.value?.toString() === 'Invalid' &&
          tempObj?.column?.colDef?.showCheckboxIcon
        ) {
          tempObj.value = '0';
        } else if (
          tempObj.column?.colDef?.showCheckboxIcon &&
          !tempObj?.node?.data?.isBottomRow
        ) {
          tempObj.value =
            tempObj.value?.toString() === 'true' ||
            tempObj.value?.toString() === '1'
              ? 1
              : 0;
        }
        if (
          tempObj.value === null ||
          tempObj.value === 'Invalid date' ||
          tempObj.value === undefined ||
          tempObj.value === '-1'
        ) {
          tempObj.value = '';
        }

        if (
          (tempObj.value?.toString()?.includes('$') ||
            tempObj.column?.colDef.exportOption?.printWithCurrency) &&
          (tempObj.column?.colDef?.alignRight ||
            tempObj.column?.colDef.cellStyle?.textAlign === 'right')
        ) {
          const formattedValue = removeDollarForNumberFiled(
            removeCommaForNumberFiled(tempObj.value || 0)
          )?.trim();
          tempObj.value = `$ ${parseFloat(formattedValue || 0).toFixed(2)}`;
        }

        if (
          tempObj.value?.toString()?.includes('\n') ||
          tempObj.value?.toString()?.includes('"')
        ) {
          tempObj.value = removeDoubleQueFiled(tempObj.value);
        }
        return customProcessCellCallback(tempObj, true);
      },
      processHeaderCallback: customProcessHeaderCallback,
      skipColumnHeaders,
      skipColumnGroupHeaders: false,
      rowHeaders: true,
    });
  };
  const ExportExcel = () => {
    const getExportColumnKeys = () => {
      try {
        const colApi = gridRef.current?.columnApi || columnApi;
        if (colApi && colApi.getAllDisplayedColumns) {
          return colApi
            .getAllDisplayedColumns()
            .map((col) => col.getColDef())
            ?.filter((x) => {
              if (hideColumnsInPdf) {
                return x.field !== hideColumnsInPdf[0];
              }
              return x;
            })
            .flatMap((column) => (column.children ? column.children : [column]))
            .filter((child) => !child.pdfExportOptions?.skipColumn)
            .map((child) => child.field);
        }
      } catch (e) {
        return columnDefs
          ?.filter((x) => {
            if (hideColumnsInPdf) {
              return x.field !== hideColumnsInPdf[0];
            }
            return x;
          })
          .flatMap((column) => (column.children ? column.children : [column]))
          ?.filter((child) => !child.pdfExportOptions?.skipColumn)
          .map((child) => child.field);
      }
    };

    return gridRef.current.api.getDataAsCsv({
      fileName: `${fileName ? `${fileName}.csv` : 'data.xlsx'}`,
      columnKeys: getExportColumnKeys(),
      processCellCallback: customProcessCellCallback,
      processHeaderCallback: customProcessHeaderCallback,
      skipColumnHeaders,
      skipColumnGroupHeaders: false,
    });
  };
  const onFirstDataRendered = useCallback(() => {
    const api = gridRef.current.api;
    if (Array.isArray(selectRowIndex)) {
      gridRef.current.api.forEachNode((node) => {
        if (selectRowIndex.indexOf(node.rowIndex) != '-1') {
          node.setSelected(true);
        }
      });
    }
    if (!isNaN(selectRowIndex)) {
      gridRef.current.api.forEachNode((node) => {
        if (node.rowIndex === selectRowIndex) {
          node.setSelected(true);
        }
      });
    }
    if (gridDataRendered) {
      gridDataRendered(api);
      const api = gridRef.current.api;
      if (Array.isArray(selectRowIndex)) {
        gridRef.current.api.forEachNode((node) => {
          if (selectRowIndex.indexOf(node.rowIndex) != '-1') {
            node.setSelected(true);
          }
        });
      }
      if (!isNaN(selectRowIndex)) {
        gridRef.current.api.forEachNode((node) => {
          if (node.rowIndex === selectRowIndex) {
            node.setSelected(true);
          }
        });
      }
      if (gridDataRendered) {
        gridDataRendered(api);
      }
    }
  }, []);
  const onFirstDataRenders = useCallback(() => {
    if (!enableFocusOnFirstRender) return;
    const api = gridRef.current?.api;
    const colId = props.focusColId;
    const rowIndex = typeof selectRowIndex === 'number' ? selectRowIndex : 0;
    api.forEachNode((node) => {
      node.setSelected(true);
    });
    if (colId) {
      api.setFocusedCell(rowIndex, colId);
      api.ensureIndexVisible(rowIndex, 'top');
    }
  }, []);
  // const onFirstDataRendered = useCallback(() => {
  //   if(!enableFocusOnFirstRender) return
  //   const api = gridRef.current?.api;
  //   const colId= props.focusColId
  //   const rowIndex= typeof selectRowIndex==='number'?selectRowIndex:0
  //   api.forEachNode((node)=>{
  //     node.setSelected(true)
  //   })
  //   if(colId){
  //     api.setFocusedCell(rowIndex,colId)
  //     api.ensureIndexVisible(rowIndex,'top')
  //   }
  // }, [props.focusColId,selectRowIndex]);
  const handleOnCellKeyDown = useCallback((e, data) => {
    const keyboardEvent = e?.event;
    const { key } = keyboardEvent;

    if (key === 'Enter' || key === ' ') {
      if (cellClickedListener) {
        cellClickedListener(e, data);
      } else if (onSelect) {
        onSelect(e, data);
      }
    }
  }, []);

  const onSortChangedGrid = useCallback(
    (e) => {
      const gridName = `${window.location.pathname?.replace('/', '')}-${
        fileName?.includes(' ') ? fileName?.split(' ')?.join('') : fileName
      }`;

      if (
        e?.columnApi?.getColumnState() &&
        Object.keys(e?.columnApi?.getColumnState())?.length > 0
      ) {
        dispatch(
          dispatchFilterAndSortFun({
            ...filterAndSortList,
            [gridName]: {
              ...filterAndSortList[gridName],
              activeURL: window.location.pathname,
              sort: e?.columnApi?.getColumnState(),
            },
          })
        );
      }
    },
    [filterAndSortList]
  );
  const addFilterForTable = React.useCallback(
    (params) => {
      const gridName = `${window.location.pathname?.replace('/', '')}-${
        fileName?.includes(' ') ? fileName?.split(' ')?.join('') : fileName
      }`;

      if (
        Object.keys(filterAndSortList)?.filter((x) => {
          return x === gridName;
        })?.length > 0
      ) {
        const filterData = filterAndSortList[gridName]?.filter;
        const sortData = filterAndSortList[gridName]?.sort;

        if (params?.api && filterData) {
          setTimeout(() => {
            params.api.setFilterModel(filterData);
          }, 1000);
        }
        if (params?.columnApi && sortData) {
          params.columnApi.applyColumnState({
            state: sortData,
          });
        }
      }
    },
    [filterAndSortList]
  );

  const mapColumnDefs = (defs = [], hideColumnsInPdf = []) => {
    if (!Array.isArray(defs)) return [];

    return defs.map((item, key) => {
      if (!item) return item; // guard against undefined

      const isActionColumn =
        typeof item.headerName === 'string' &&
        ['action', 'actions'].includes(item.headerName.toLowerCase());

      const newItem = { ...item };

      if (isActionColumn) {
        newItem.pdfExportOptions = {
          ...(newItem.pdfExportOptions || {}),
          skipColumn: true,
        };
      }

      if (
        key === 0 &&
        !(
          newItem.showCheckboxIcon ||
          newItem.hideFilterIcon ||
          newItem.pdfExportOptions?.skipColumn ||
          (typeof newItem.headerName === 'string' &&
            newItem.headerName.toLowerCase().includes('action')) ||
          (hideColumnsInPdf && hideColumnsInPdf.length > 0)
        )
      ) {
        if (Array.isArray(newItem.children) && newItem.children.length > 0) {
          newItem.children = [
            { ...newItem.children[0], sort: 'asc' },
            ...newItem.children.slice(1),
          ];
        }
        newItem.sort = 'asc';
      } else if (
        key === 1 &&
        defs[0]?.sort !== 'asc' &&
        !newItem.showCheckboxIcon
      ) {
        newItem.sort = 'asc';
      } else if (
        key === 2 &&
        defs[0]?.sort !== 'asc' &&
        defs[1]?.sort !== 'asc'
      ) {
        newItem.sort = 'asc';
      } else {
        newItem.sort = '';
      }

      return newItem;
    });
  };

  let finalColumnDefs;
  if (noGlobalSort) {
    finalColumnDefs = columnDefs;
  } else if (applyFilter) {
    finalColumnDefs = mapColumnDefs(columnDefs);
  } else {
    finalColumnDefs = mapColumnDefs(columnDefs);
  }

  if (!noGlobalSort) {
    finalColumnDefs = mapColumnDefs(finalColumnDefs);
  }

  const getRowHeight = (params) => {
    const data = params.data || {};
    if (data?.hideInGrid && data?.isBottomRowSup) {
      return 0; // Hide the row by 0
    }
    return 38; // Default row height
  };

  const getRowStyle = (params) => {
    const data = params.data || {};
    if (data?.hideInGrid && data?.isBottomRowSup) {
      return { display: 'none' };
    }
    return null;
  };

  const gridOptions = {
    getRowStyle: getRowStyle,
    getRowHeight: getRowHeight,
    suppressRowTransform: true, // Suppress row transform to remove empty space
    suppressKeyboardEvent,
  };

  // Focus on internal elements of Grid
  const GRID_CELL_CLASSNAME = 'ag-cell';

  function getAllFocusableElementsOf(el) {
    return Array.from(
      el.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((focusableEl) => {
      const isDisabled =
        focusableEl.disabled === true ||
        focusableEl.getAttribute?.('aria-disabled') === 'true';
      return focusableEl.tabIndex !== -1 && !isDisabled;
    });
  }

  function getEventPath(event) {
    const path = [];
    let currentTarget = event.target;

    while (currentTarget) {
      path.push(currentTarget);
      currentTarget = currentTarget.parentElement;
    }

    return path;
  }

  /**
   * Capture whether the user is tabbing forwards or backwards and suppress keyboard event if tabbing
   * outside of the children
   */
  /**
   * Capture whether the user is tabbing forwards or backwards and suppress keyboard event if tabbing
   * outside of the children
   */
  function suppressKeyboardEvent(params) {
    const { event, api, columnApi, node, column } = params;
    const { key, shiftKey } = event;
    //wriiten here because ag grid default handling messing up when page down key pressed two times rapidly
    // if (key === 'PageDown' || key === 'PageUp') {
    //   try {
    //     const api = gridRef.current?.api;
    //     const focused = api && api.getFocusedCell ? api.getFocusedCell() : null;
    //     const eventforFunc = {
    //       rowIndex:
    //         typeof focused?.rowIndex === 'number' ? focused.rowIndex : 0,
    //       column: focused?.column,
    //       event,
    //     };
    //     if (onCellKeyDown) {
    //       try {
    //         onCellKeyDown(eventforFunc, reduxState);
    //       } catch (err) {}
    //     }
    //     try {
    //       handleOnCellKeyDown(eventforFunc, reduxState);
    //     } catch (err) {}
    //   } catch (err) {}
    //   try {
    //     event.preventDefault();
    //   } catch (e) {}
    //   return true;
    // }
    const path = getEventPath(event);
    const isTabForward = key === 'Tab' && shiftKey === false;
    const isTabBackward = key === 'Tab' && shiftKey === true;

    let suppressEvent = false;

    // Handle cell children tabbing
    if (isTabForward || isTabBackward) {
      const eGridCell = path.find((el) => {
        if (el.classList === undefined) return false;
        return el.classList.contains(GRID_CELL_CLASSNAME);
      });

      if (!eGridCell) {
        return suppressEvent;
      }

      const focusableChildrenElements = getAllFocusableElementsOf(eGridCell);
      const lastCellChildEl =
        focusableChildrenElements[focusableChildrenElements.length - 1];
      const firstCellChildEl = focusableChildrenElements[0];

      // Helper: last row + last displayed column → side bar first, then Total Results
      const focusSideBarOrTotalResultsIfLastCell = () => {
        const allColumns = columnApi.getAllDisplayedColumns();
        if (!allColumns || !allColumns.length) return false;

        const lastColumn = allColumns[allColumns.length - 1];
        const rowCount = api.getModel().getRowCount();

        if (
          !lastColumn ||
          node.rowIndex !== rowCount - 1 ||
          column.colId !== lastColumn.colId
        ) {
          return false;
        }

        // Check if there are pinned bottom rows and navigate to the first cell
        const hasPinnedBottomRows =
          api?.getPinnedBottomRowCount?.() > 0 ||
          (pinnedBottomRowData && pinnedBottomRowData.length > 0);
        if (hasPinnedBottomRows) {
          try {
            const pinnedBottomContainer = document.querySelector(
              '.ag-floating-bottom-container'
            );
            if (pinnedBottomContainer) {
              const horizontalViewport = document.querySelector(
                '.ag-body-horizontal-scroll-viewport'
              );
              if (horizontalViewport) {
                horizontalViewport.scrollLeft = 0;
              }

              const firstFocusableCell = pinnedBottomContainer.querySelector(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
              );
              if (firstFocusableCell) {
                event.preventDefault();
                firstFocusableCell.focus();
                firstFocusableCell.scrollIntoView({
                  behavior: 'auto',
                  block: 'nearest',
                  inline: 'nearest',
                });
                return true;
              }

              const firstCell = pinnedBottomContainer.querySelector('.ag-cell');
              if (firstCell) {
                event.preventDefault();
                firstCell.focus();
                firstCell.scrollIntoView({
                  behavior: 'auto',
                  block: 'nearest',
                  inline: 'nearest',
                });
                return true;
              }
            }
          } catch (e) {}
        }

        const panelRoot = sideBarPanelRef?.current;
        if (panelRoot && panelRoot.offsetParent) {
          const buttonsContainer = panelRoot.querySelector('.ag-side-buttons');
          const button =
            (buttonsContainer && buttonsContainer.querySelector('button')) ||
            null;
          const target = button || panelRoot;

          if (target.tabIndex === -1) {
            target.tabIndex = 0;
          }

          try {
            event.preventDefault();
          } catch (e) {}
          target.focus();
          return true;
        }

        if (totalResultsRef.current) {
          try {
            event.preventDefault();
          } catch (e) {}
          totalResultsRef.current.focus();
          return true;
        }

        return false;
      };

      // Suppress keyboard event if tabbing forward within the cell and the current focused element is not the last child
      if (focusableChildrenElements.length === 0) {
        if (isTabForward) {
          // OLD behavior: last cell → Total Results, now extended to side bar first
          if (focusSideBarOrTotalResultsIfLastCell()) {
            return true;
          }
        }
        return false;
      }

      const currentIndex = focusableChildrenElements.indexOf(
        document.activeElement
      );

      if (isTabForward) {
        const isLastChildFocused =
          lastCellChildEl && document.activeElement === lastCellChildEl;

        if (!isLastChildFocused) {
          // OLD behavior: move forward within icons/controls in the cell
          suppressEvent = true;
          if (currentIndex == -1 || document.activeElement === eGridCell) {
            event.preventDefault();
            focusableChildrenElements[currentIndex + 1].focus();
          }
        } else {
          // OLD behavior: last child + last cell → Total Results, now extended to side bar first
          if (focusSideBarOrTotalResultsIfLastCell()) {
            return true;
          }
        }
      }
      // Suppress keyboard event if tabbing backwards within the cell, and the current focused element is not the first child
      else {
        const cellHasFocusedChildren =
          eGridCell.contains(document.activeElement) &&
          eGridCell !== document.activeElement;

        // OLD behavior: if nothing inside is focused yet, jump to last child first
        if (!cellHasFocusedChildren) {
          lastCellChildEl.focus();
          // Cancel keyboard press, so that it doesn't focus on the last child and then pass through the keyboard press to
          // move to the 2nd last child element
          event.preventDefault();
          return true;
        }

        const isFirstChildFocused =
          firstCellChildEl && document.activeElement === firstCellChildEl;
        if (!isFirstChildFocused) {
          // OLD behavior: Shift+Tab backwards within icons/controls
          suppressEvent = true;
          if (currentIndex == -1 || document.activeElement === eGridCell) {
            event.preventDefault();
            if (focusableChildrenElements[currentIndex - 1]) {
              focusableChildrenElements[currentIndex - 1].focus();
            }
          }
        }
      }
    }

    return suppressEvent;
  }

  // -------End------- Focus on internal elements of Grid
  return (
    <>
      <Spinner load={tableLoader} />
      <div className="devider-line panel-header">
        {!fullScreenView && addTxt ? (
          <a
            href="#"
            data-testid="addTBillRate"
            className={`${
              disableAddAction ? 'frr-disable-anchor' : ''
            } icon-plus float-left`}
            onClick={disableAddAction ? () => {} : addAction}
          >
            <h2 className="my-2">{addTxt}</h2>
          </a>
        ) : (
          <div className="prefix" />
        )}
        {!fullScreenView ? (
          <div className="float-left mt-2">
            {handleAddNewRow ? (
              <a
                href="#"
                role="button"
                aria-disabled={disableAdd}
                data-testid="addTBillRate"
                className={`icon-plus float-left ${
                  disableAdd ? 'frr-disable-anchor' : ''
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  if (disableAdd) return;
                  handleAddNewRow(gridParams);
                }}
              >
                <h2 className="my-2">{addButtonText}</h2>
              </a>
            ) : (
              <p className="no-margin tbl-help-text p-1">
                {helpMessage ||
                  (cellClickedListener
                    ? '* On Double Click of Results, system should navigate to Detail page'
                    : '')}
              </p>
            )}
          </div>
        ) : (
          <div className="float-left" />
        )}
        <div className="float-right th-icon-group mt-2">
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="filter-tooltip" style={{ zIndex: 9999 }}>
                Reset All Filters
              </Tooltip>
            }
          >
            {applyFilter ? (
              <div
                className="th-icon ic-filter-activate"
                data-testid="handleClearFilter"
                role="button"
                onClick={handleClearFilter}
                title="Reset All Filters"
                tabIndex={0}
              >
                {' '}
                <span className="ic-title"> Filter </span>{' '}
              </div>
            ) : (
              <div className="th-icon ic-filter">
                <span className="ic-title"> Filter </span>{' '}
              </div>
            )}
          </OverlayTrigger>
          {handleViewHistory && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="history-tooltip">View History</Tooltip>}
            >
              <div
                className="th-icon ic-history"
                role="button"
                onClick={() => handleViewHistory(gridApi)}
                tabIndex="0"
              >
                {' '}
                <span className="ic-title"> History </span>
              </div>
            </OverlayTrigger>
          )}
          {exportFile && (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="history-tooltip" style={{ zIndex: 9999 }}>
                  {' '}
                  Actions{' '}
                </Tooltip>
              }
            >
              <div className="th-icon ic-actions">
                <PDFExportPanel
                  exportAllTpPDFOne={exportAllTpPDFOne}
                  providerAllClaimPDFExport={providerAllClaimPDFExport}
                  handleClickOpenDelete={handleClickOpenDelete}
                  goToClient={goToClient}
                  goToGroup={goToGroup}
                  freezeDisabled={freezeDisabled}
                  download={download}
                  goToRebateManage={goToRebateManage}
                  planByCGP={planByCGP}
                  isPlanScreen={isPlanScreen || false}
                  gridApi={gridApi}
                  columnApi={columnApi}
                  fileName={fileName}
                  hideColumnsInPdf={hideColumnsInPdf}
                  childRef={gridRef}
                  ExportCsv={ExportCsv}
                  ExportExcel={ExportExcel}
                  footerVariable={footerVariable}
                  showFooterForPDF={showFooterForPDF}
                  info={info}
                  isScrollOn={isScrollOn}
                  skipHeaderRow={skipHeaderRow}
                  reportName={reportName}
                  defaultColWidth={defaultColWidth}
                  exportOnlyTotal={exportOnlyTotal}
                  isAllocatePaymentScreen={isAllocatePaymentScreen}
                  uraFlag={uraFlag}
                  activeInvoiceNum={activeInvoiceNum}
                  activeCheckLogNum={activeCheckLogNum}
                  checkAllocatePqasScreen={checkAllocatePqasScreen}
                  researchActions={researchActions}
                  handleResearchInvoiceAmount={handleResearchInvoiceAmount}
                  handleResearchAdjustments={handleResearchAdjustments}
                  handleResearchPayments={handleResearchPayments}
                  navigateHandler={navigateHandler}
                  mailoutHandler={mailoutHandler}
                  showMailoutOptions={showMailoutOptions}
                  showAdditionalOptions={showAdditionalOptions}
                  showGoToNDCOptions={showGoToNDCOptions}
                  customPDFExport={customPDFExport}
                  exportAllTpPDF={exportAllTpPDF}
                  exportToPDF={exportToPDF}
                  exportAllE={exportAllE}
                  exportAllLEFTE={exportAllLEFTE}
                  showExportPdfOption={showExportPdfOption}
                  exportAllToXlsx={exportAllToXlsx}
                  exportAllToXlsx1={exportAllToXlsx1}
                  exportAllToXlsx2={exportAllToXlsx2}
                  exportAllToCSV={exportAllToCSV}
                  skipAlertPopup={skipAlertPopup}
                  handleOptionForDisputedClaims={
                    typeof handleOptionForDisputedClaims === 'function'
                      ? (value) => {
                          handleOptionForDisputedClaims(value);
                        }
                      : false
                  }
                  handleFreezeValuesPopup={
                    typeof handleFreezeValuesPopup === 'function'
                      ? () => {
                          handleFreezeValuesPopup();
                        }
                      : false
                  }
                />
              </div>
            </OverlayTrigger>
          )}
          {exportWithOtherOption && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="history-tooltip"> Actions </Tooltip>}
            >
              <div className="th-icon ic-actions">
                <PDFExportPanel
                  gridApi={gridApi}
                  columnApi={columnApi}
                  fileName={fileName}
                  hideColumnsInPdf={hideColumnsInPdf}
                  childRef={gridRef}
                  exportAllE={exportAllE}
                  exportAllLEFTE={exportAllLEFTE}
                  ExportCsv={ExportCsv}
                  ExportExcel={ExportExcel}
                  footerVariable={footerVariable}
                  showFooterForPDF={showFooterForPDF}
                  ShowStartDateOption={
                    !(
                      props.handleViewDetailsForInvoiceDetail ||
                      props.handleViewDetailsForClaimDetail ||
                      props.handleViewDetailsForRebatePriceDetails
                    )
                  }
                  handleViewDetailsForInvoiceDetail={
                    props.handleViewDetailsForInvoiceDetail
                  }
                  handleRedirectURLLink={props.handleRedirectURLLink}
                  handleViewDetailsForClaimDetail={
                    props.handleViewDetailsForClaimDetail
                  }
                  claimHandleRedirectURLLink={props.claimHandleRedirectURLLink}
                  isExport={!props.handleViewDetailsForClaimDetail}
                  handleViewDetailsForRebatePriceDetails={
                    props.handleViewDetailsForRebatePriceDetails
                  }
                  handleGoToNdcURLLink={(data) =>
                    props.handleGoToNdcURLLink(data)
                  }
                  skipAlertPopup={skipAlertPopup}
                  handleOptionForDisputedClaims={
                    typeof handleOptionForDisputedClaims === 'function'
                      ? (value) => {
                          handleOptionForDisputedClaims(value);
                        }
                      : false
                  }
                  handleFreezeValuesPopup={
                    typeof handleFreezeValuesPopup === 'function'
                      ? () => {
                          handleFreezeValuesPopup();
                        }
                      : false
                  }
                />
              </div>
            </OverlayTrigger>
          )}
          {(handleFullScreenView || handleFullScreenViewClick) && (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="fullScreen-tooltip">
                  {fullScreenView ? 'Minimize Screen' : 'Full Screen'}
                </Tooltip>
              }
            >
              <div
                className={
                  fullScreenView
                    ? 'th-icon ic-fulScreen-exit'
                    : 'th-icon ic-fulScreen'
                }
                role="button"
                data-testid="setFullScreenView"
                onClick={handleFullScreenViewClick}
                tabIndex="0"
              >
                <span className="ic-title">
                  {' '}
                  {fullScreenView ? 'Minimize Screen' : 'Full Screen'}{' '}
                </span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      </div>
      <div className="panel">
        <div className="FRR-custom-table tbl-manufacturer-home tbl-manufacturer-inner">
          <div
            className={`FRR-custom-table record-align ${
              isModalTable
                ? 'modal-table'
                : rowData && rowData.length > 0
                ? 'data-table'
                : 'empty-table'
            }`}
          >
            {showError && (
              <DisplayErrorMessages
                errorMessages={[constantMessageData.NO_DATA_FOUND_ERROR]}
              />
            )}
            <div
              className="ag-theme-alpine"
              style={{ height: gridHeight || '100%' }}
            >
              <div className="clearfix" />
              {isAllocatePayment ? (
                <AgGridReact
                  {...gridOptions}
                  ref={gridRef}
                  headerHeight={headerHeight ?? 45}
                  rowHeight={38}
                  frameworkComponents={frameworkComponents}
                  loadingCellRenderer={loadingCellRenderer}
                  onGridReady={handleOnGridReady}
                  onRowDataUpdated={onRowDataUpdated}
                  onModelUpdated={onModelUpdated}
                  onBodyScrollEnd={onBodyScrollEnd}
                  loadingCellRendererParams={loadingCellRendererParams}
                  rowData={rowData || []}
                  immutableData={true}
                  getRowId={(params) => params.data.id}
                  columnDefs={finalColumnDefs}
                  context={context}
                  defaultColDef={defaultColDef}
                  onCellDoubleClicked={cellClickedListener}
                  onFilterChanged={onFilterChangedWrapper}
                  onColumnPinned={onColumnPinned}
                  onCellValueChanged={onCellValueChanged}
                  onSelectionChanged={onSelectionChanged}
                  accentedSort
                  onSortChanged={(e) => {
                    if (onSortChanged) {
                      onSortChanged(e);
                    }
                    onSortChangedGrid(e);
                  }}
                  rowSelection={rowSelection || 'single'}
                  rowMultiSelectWithClick={rowMultiSelectWithClick || false}
                  sideBar={{
                    toolPanels: [
                      {
                        id: 'columns',
                        labelDefault: 'Columns',
                        labelKey: 'columns',
                        iconKey: 'columns',
                        toolPanel: 'agColumnsToolPanel',
                        toolPanelParams: {
                          suppressPivotMode: true,
                          suppressValues: true,
                          suppressRowGroups: true,
                          suppressColumnSelectAll: true,
                        },
                      },
                    ],
                  }}
                  onCellClicked={onSelect || (() => {})}
                  components={components}
                  suppressMenuHide
                  overlayNoRowsTemplate={
                    overlayNoRowsTemplate || 'There is no data to display.'
                  }
                  onFirstDataRendered={onFirstDataRendered}
                  onFirstDataRenders={onFirstDataRenders}
                  singleClickEdit={singleClickEdit || false}
                  popupParent={
                    childPopup ? null : document.querySelector('body')
                  }
                  suppressDragLeaveHidesColumns
                  enableRangeSelection
                  suppressMultiRangeSelection
                  navigateToNextCell={navigateToNextCell}
                  tabToNextCell={tabToNextCell}
                  suppressRowClickSelection={suppressRowClickSelection}
                  enterMovesDown={enterMovesDown}
                  onCellFocused={onCellFocused}
                  rowClassRules={rowClassRules}
                  pinnedBottomRowData={pinnedBottomRowData}
                  onCellKeyDown={(e) => {
                    if (onCellKeyDown) {
                      onCellKeyDown(e, reduxState);
                    }
                    handleOnCellKeyDown(e, reduxState);
                  }}
                  onColumnMoved={() => handleOnColumnMoved(gridRef)}
                  getContextMenuItems={[]}
                />
              ) : (
                <AgGridReact
                  {...gridOptions}
                  ref={gridRef}
                  headerHeight={headerHeight ?? 45}
                  rowHeight={38}
                  frameworkComponents={frameworkComponents}
                  loadingCellRenderer={loadingCellRenderer}
                  onGridReady={handleOnGridReady}
                  onRowDataUpdated={onRowDataUpdated}
                  onModelUpdated={onModelUpdated}
                  onBodyScrollEnd={onBodyScrollEnd}
                  loadingCellRendererParams={loadingCellRendererParams}
                  rowData={rowData || []}
                  columnDefs={finalColumnDefs}
                  context={context}
                  defaultColDef={defaultColDef}
                  onCellDoubleClicked={cellClickedListener}
                  onFilterChanged={onFilterChangedWrapper}
                  onColumnPinned={onColumnPinned}
                  onCellValueChanged={onCellValueChanged}
                  onSelectionChanged={onSelectionChanged}
                  accentedSort
                  onSortChanged={(e) => {
                    if (onSortChanged) {
                      onSortChanged(e);
                    }
                    onSortChangedGrid(e);
                  }}
                  rowSelection={rowSelection || 'single'}
                  rowMultiSelectWithClick={rowMultiSelectWithClick || false}
                  sideBar={{
                    toolPanels: [
                      {
                        id: 'columns',
                        labelDefault: 'Columns',
                        labelKey: 'columns',
                        iconKey: 'columns',
                        toolPanel: 'agColumnsToolPanel',
                        toolPanelParams: {
                          suppressPivotMode: true,
                          suppressValues: true,
                          suppressRowGroups: true,
                          suppressColumnSelectAll: true,
                        },
                      },
                    ],
                  }}
                  onCellClicked={onSelect || (() => {})}
                  components={components}
                  suppressMenuHide
                  overlayNoRowsTemplate={
                    overlayNoRowsTemplate || 'There is no data to display.'
                  }
                  onFirstDataRendered={onFirstDataRendered}
                  onFirstDataRenders={onFirstDataRenders}
                  singleClickEdit={singleClickEdit || false}
                  popupParent={
                    childPopup ? null : document.querySelector('body')
                  }
                  suppressDragLeaveHidesColumns
                  enableRangeSelection
                  suppressMultiRangeSelection
                  navigateToNextCell={navigateToNextCell}
                  tabToNextCell={tabToNextCell}
                  suppressRowClickSelection={suppressRowClickSelection}
                  enterMovesDown={enterMovesDown}
                  onCellFocused={onCellFocused}
                  rowClassRules={rowClassRules}
                  pinnedBottomRowData={pinnedBottomRowData}
                  onCellKeyDown={(e) => {
                    if (onCellKeyDown) {
                      onCellKeyDown(e, reduxState);
                    }
                    handleOnCellKeyDown(e, reduxState);
                  }}
                  onColumnMoved={() => handleOnColumnMoved(gridRef)}
                  getContextMenuItems={[]}
                />
              )}
            </div>
          </div>
        </div>
        {hideTotalCount ? null : (
          <p className="total-results" tabIndex="0" ref={totalResultsRef}>
            Total Results:
            <b>{` ${displayCount?.toLocaleString('en-US')}`}</b>
          </p>
        )}
      </div>
    </>
  );
});
export default TableGridWithFeatures;
